import * as React from "react";

import {
  DataSourceAddressAutocompleteProvider,
  DataSourceAddressParseProvider,
  DataSourceCheckoutRegionsProvider,
  useLocalizationProvider,
} from "../../../Common";

import { DataMutationCreateCustomerAddressProvider } from "../data-mutation--create-customer-address";
import { DataMutationShippingSetAuthorityToLeaveProvider } from "../data-mutation--shipping-set-authority-to-leave";
import { DataMutationShippingMemberSetAuthorityToLeaveProvider } from "../data-mutation--shipping-member-set-authority-to-leave";
import { DataMutableSourceShippingClientStorageDataProvider } from "../data-mutable-source-shipping-client-storage-data-provider";
import { useReactMyBagInitialState } from "../react-my-bag-initial-state-provider";
import { ShippingFormProvider } from "../shipping-form-provider";
import { DataSourceLegacyCheckoutConfigProvider } from "../data-source--legacy-checkout-config";

import { DeliveryDetailsUserExperienceProvider } from "./delivery-details-user-experience-provider";
import { DeliveryDetailsPaymentPageKickoffProvider } from "./delivery-details-payment-page-kickoff-provider";
import { DeliveryDetailsFormRefProvider } from "./delivery-details-form-ref-provider";
import { DataMutableSourceShippingSessionStorageDataProvider } from "../data-mutable-source-shipping-session-storage-data-provider";
import { DataMutationDeleteCustomerAddressProvider } from "../data-mutation--delete-customer-address";

export const DeliveryDetailsProvider: React.FunctionComponent = (props) => {
  const { countryCode } = useLocalizationProvider();
  return (
    <DataSourceCheckoutRegionsProvider
      countryCode={countryCode}
      useInitialState={useReactMyBagInitialState}
    >
      <DataSourceAddressAutocompleteProvider>
        <DataSourceAddressParseProvider>
          <DataMutableSourceShippingClientStorageDataProvider>
            <DataMutableSourceShippingSessionStorageDataProvider>
              <DataMutationCreateCustomerAddressProvider
                useInitialState={useReactMyBagInitialState}
              >
                <DataMutationDeleteCustomerAddressProvider
                  useInitialState={useReactMyBagInitialState}
                >
                  <DataMutationShippingSetAuthorityToLeaveProvider
                    useInitialState={useReactMyBagInitialState}
                  >
                    <DataMutationShippingMemberSetAuthorityToLeaveProvider
                      useInitialState={useReactMyBagInitialState}
                    >
                      <ShippingFormProvider
                        useInitialState={useReactMyBagInitialState}
                      >
                        <DataSourceLegacyCheckoutConfigProvider
                          useInitialState={useReactMyBagInitialState}
                        >
                          <DeliveryDetailsFormRefProvider>
                            <DeliveryDetailsPaymentPageKickoffProvider>
                              <DeliveryDetailsUserExperienceProvider>
                                {props.children || []}
                              </DeliveryDetailsUserExperienceProvider>
                            </DeliveryDetailsPaymentPageKickoffProvider>
                          </DeliveryDetailsFormRefProvider>
                        </DataSourceLegacyCheckoutConfigProvider>
                      </ShippingFormProvider>
                    </DataMutationShippingMemberSetAuthorityToLeaveProvider>
                  </DataMutationShippingSetAuthorityToLeaveProvider>
                </DataMutationDeleteCustomerAddressProvider>
              </DataMutationCreateCustomerAddressProvider>
            </DataMutableSourceShippingSessionStorageDataProvider>
          </DataMutableSourceShippingClientStorageDataProvider>
        </DataSourceAddressParseProvider>
      </DataSourceAddressAutocompleteProvider>
    </DataSourceCheckoutRegionsProvider>
  );
};
